import { Extension } from '@tiptap/core'
import { CitationMinuteNodes } from '../../../../../../backend/src/citations/minutes-citations-api.dto'
import { CitationPluginOptions, ResourceInfo, createCitationPlugin } from './citation-plugin'

export type CitationExtensionOptions = {
  citations: CitationMinuteNodes
  resources: ResourceInfo[]
  formatPageLabel: (page: number) => string
  onOpenDocument: ((event: { resourceId: number; resourcePageNumber: number }) => void) | null
  onOpenMeeting: ((event: { startSentenceId: string; endSentenceId: string }) => void) | null
}

export const CitationExtension = Extension.create<CitationExtensionOptions>({
  name: 'citation',

  addOptions() {
    return {
      citations: {},
      resources: [],
      formatPageLabel: (page: number) => `Page ${page}`,
      onOpenDocument: null,
      onOpenMeeting: null,
    }
  },

  addProseMirrorPlugins() {
    const pluginOptions: CitationPluginOptions = {
      citations: this.options.citations,
      resources: this.options.resources,
      formatPageLabel: this.options.formatPageLabel,
      onOpenDocument: this.options.onOpenDocument,
      onOpenMeeting: this.options.onOpenMeeting,
    }

    return [createCitationPlugin(pluginOptions)]
  },
})
